(function () {
var $8e4372b200518a6f$var$duration = 3000;
var $8e4372b200518a6f$var$activeClass = "opacity-100";
var $8e4372b200518a6f$var$timers = {};
var $8e4372b200518a6f$export$2cd8252107eb640b = function() {
    if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var wrapper = entry.target;
                var id = wrapper.dataset.id;
                // This targets the wrapper div on the image.
                // We might need to make this more specific in the future.
                var images = wrapper.querySelectorAll("div");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var image = _step.value;
                        image.style.transitionDuration = "".concat($8e4372b200518a6f$var$duration, "ms");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (entry.isIntersecting) setTimeout(function() {
                    var timer = setInterval(function() {
                        $8e4372b200518a6f$var$fade(images, true);
                    }, $8e4372b200518a6f$var$duration);
                    $8e4372b200518a6f$var$timers[id] = timer;
                }, wrapper.dataset.delay);
                else {
                    clearInterval($8e4372b200518a6f$var$timers[id]);
                    delete $8e4372b200518a6f$var$timers[id];
                }
            });
        }, {});
        document.querySelectorAll(".js-cross-fade").forEach(function(wrapper) {
            observer.observe(wrapper);
        });
    }
};
var $8e4372b200518a6f$var$fade = function(images) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var image = _step.value;
            if (image.classList.contains($8e4372b200518a6f$var$activeClass)) {
                image.classList.remove($8e4372b200518a6f$var$activeClass);
                if (image.nextElementSibling) image.nextElementSibling.classList.add($8e4372b200518a6f$var$activeClass);
                else images[0].classList.add($8e4372b200518a6f$var$activeClass);
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};


var $08e8db7071ed48c0$var$__assign = undefined && undefined.__assign || function() {
    return ($08e8db7071ed48c0$var$__assign = Object.assign || function(t) {
        for(var i, a = 1, n = arguments.length; a < n; a++)for(var s in i = arguments[a])Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
        return t;
    }).apply(this, arguments);
}, $08e8db7071ed48c0$export$1567cc001e3d0c1d = function() {
    function t(t, i, a) {
        var n = this;
        this.endVal = i, this.options = a, this.version = "2.1.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.count = function(t) {
            n.startTime || (n.startTime = t);
            var _$i = t - n.startTime;
            n.remaining = n.duration - _$i, n.useEasing ? n.countDown ? n.frameVal = n.startVal - n.easingFn(_$i, 0, n.startVal - n.endVal, n.duration) : n.frameVal = n.easingFn(_$i, n.startVal, n.endVal - n.startVal, n.duration) : n.countDown ? n.frameVal = n.startVal - (n.startVal - n.endVal) * (_$i / n.duration) : n.frameVal = n.startVal + (n.endVal - n.startVal) * (_$i / n.duration), n.countDown ? n.frameVal = n.frameVal < n.endVal ? n.endVal : n.frameVal : n.frameVal = n.frameVal > n.endVal ? n.endVal : n.frameVal, n.frameVal = Number(n.frameVal.toFixed(n.options.decimalPlaces)), n.printValue(n.frameVal), _$i < n.duration ? n.rAF = requestAnimationFrame(n.count) : null !== n.finalEndVal ? n.update(n.finalEndVal) : n.callback && n.callback();
        }, this.formatNumber = function(t) {
            var _$i, _$a, s, e, r = t < 0 ? "-" : "";
            _$i = Math.abs(t).toFixed(n.options.decimalPlaces);
            var o = (_$i += "").split(".");
            if (_$a = o[0], s = o.length > 1 ? n.options.decimal + o[1] : "", n.options.useGrouping) {
                e = "";
                for(var l = 0, h = _$a.length; l < h; ++l)0 !== l && l % 3 == 0 && (e = n.options.separator + e), e = _$a[h - l - 1] + e;
                _$a = e;
            }
            return n.options.numerals && n.options.numerals.length && (_$a = _$a.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            })), r + n.options.prefix + _$a + s + n.options.suffix;
        }, this.easeOutExpo = function(t, i, a, n) {
            return a * (1 - Math.pow(2, -10 * t / n)) * 1024 / 1023 + i;
        }, this.options = $08e8db7071ed48c0$var$__assign($08e8db7071ed48c0$var$__assign({}, this.defaults), a), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(i), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof t ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", void 0 !== window && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return n.handleScroll(n);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return t.prototype.handleScroll = function(t) {
        if (t && window) {
            var i = window.innerHeight + window.scrollY, a = t.el.offsetTop + t.el.offsetHeight;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay)) : window.scrollY > a && !t.paused && t.reset();
        }
    }, t.prototype.determineDirectionAndSmartEasing = function() {
        var _$t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > _$t;
        var i = _$t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold) {
            this.finalEndVal = _$t;
            var a = this.countDown ? 1 : -1;
            this.endVal = _$t + a * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = _$t, this.finalEndVal = null;
        this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, t.prototype.start = function(t) {
        this.error || (this.callback = t, this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, t.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, t.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, t.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal || this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, t.prototype.printValue = function(t) {
        var i = this.formattingFn(t);
        "INPUT" === this.el.tagName ? this.el.value = i : "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = i : this.el.innerHTML = i;
    }, t.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, t.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: " + t, null);
    }, t.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, t;
}();


var $e7748b6352d9b986$export$2cd8252107eb640b = function() {
    if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) $e7748b6352d9b986$var$countUp(entry.target);
            });
        }, {});
        document.querySelectorAll(".js-stats").forEach(function(wrapper) {
            observer.observe(wrapper);
        });
    }
};
var $e7748b6352d9b986$var$countUp = function(stat) {
    var _stat_dataset = stat.dataset, number = _stat_dataset.number, prefix = _stat_dataset.prefix, suffix = _stat_dataset.suffix;
    var countUp = new (0, $08e8db7071ed48c0$export$1567cc001e3d0c1d)(stat, number, {
        prefix: prefix,
        suffix: suffix
    });
    countUp.start();
};



document.addEventListener("DOMContentLoaded", function() {
    document.documentElement.classList.remove("no-js");
    // Component initializations
    $8e4372b200518a6f$export$2cd8252107eb640b();
    $e7748b6352d9b986$export$2cd8252107eb640b();
});

})();
//# sourceMappingURL=app.js.map
